/**
 * DomainHeroIllustration.tsx — hero-illustrasjon for /domener
 *
 * Tre isometriske plattformer koblet med prikkede linjer: adressefelt (navnet),
 * klode (nettet) og prislapper (pris). Samme stil og temafarger som de andre
 * produktsidene; kun blå og grå aksenter.
 */

import { Box, iso } from '@/components/product/iso';
import styles from '@/components/product/illustrations.module.css';
import { AddressBar, Globe, PriceTag } from './parts';

export default function DomainHeroIllustration({ label }: { label: string }) {
  const A = { x: -2.5, y: 0.5 }; // adressefelt
  const B = { x: -2.5, y: -5.5 }; // klode
  const C = { x: 3.5, y: -3.5 }; // prislapper
  const size = 5;

  const [gx, gy] = iso(B.x + size / 2, B.y + size / 2, 0.3).split(',').map(Number);

  return (
    <svg className={styles.scene} viewBox="110 40 660 420" role="img" aria-label={label}>
      <polyline className={styles.link} points={`${iso(A.x + 2, A.y, 0)} ${iso(B.x + 2.5, B.y + size, 0)}`} />
      <polyline className={styles.link} points={`${iso(B.x + size, B.y + 3, 0)} ${iso(C.x + 0.5, C.y, 0)}`} />
      <polyline className={styles.link} points={`${iso(A.x + size, A.y + 2, 0)} ${iso(C.x, C.y + 4.5, 0)}`} />

      {/* Bakerst: klode */}
      <Box x={B.x} y={B.y} z={0} w={size} d={size} h={0.3} top={styles.top} left={styles.left} right={styles.right} />
      <Globe cx={gx} cy={gy - 6} />

      {/* Høyre: to prislapper */}
      <Box x={C.x} y={C.y} z={0} w={size} d={size} h={0.3} top={styles.top} left={styles.left} right={styles.right} />
      <PriceTag x={C.x + 1.4} y={C.y + 0.6} z={0.3} />
      <PriceTag x={C.x + 1.2} y={C.y + 2.5} z={0.3} />

      {/* Foran: adressefelt */}
      <Box x={A.x} y={A.y} z={0} w={size} d={size} h={0.3} top={styles.top} left={styles.left} right={styles.right} />
      <AddressBar x={A.x + 0.3} y={A.y + 1.8} z={0.3} />
    </svg>
  );
}
